import { TooltipProvider as ShadcnTooltipProvider } from '@/components/tooltip/tooltip';

interface TooltipProviderProps {
  children: React.ReactNode;
}

export default function TooltipProvider({ children }: TooltipProviderProps) {
  return <ShadcnTooltipProvider delay={0}>{children}</ShadcnTooltipProvider>;
}
